<template>
<!-- 回访详情 -->
<el-drawer size="50%" :with-header="false" :visible.sync="customerDrawer" custom-class="member-detail" :wrapperClosable="false" :close-on-press-escape="false">
    <div class="drawerContent">
        <div class="drawerHead">
            <div class="drawerHeadTop">
                <div class="headLeft">
                    <el-avatar shape="square"></el-avatar>
                    <div class="nameMsg">
                        <p class="name">{{ customer.realname }}</p>
                    </div>
                </div>
                <div class="headRight">
                    <i class="pointer el-icon-close left" @click="closeShowCustomerDrawer"></i>
                </div>
            </div>
            <div class="drawerHeadBot">
                <div>
                    <p class="bot-first">电话</p>
                    <p class="bot-second mobile">{{ customer.mobile }}</p>
                </div>
                <div>
                    <p class="bot-first">重要程度</p>
                    <p class="bot-second">{{ customer.level }}</p>
                </div>
                <div>
                    <p class="bot-first">客户状态</p>
                    <p class="bot-second">{{ customer.status }}</p>
                </div>
                <div>
                    <p class="bot-first">跟进人</p>
                    <p class="bot-second">{{ customer.user }}</p>
                </div>
            </div>
        </div>
    </div>
    <el-tabs v-model="activeName">
        <el-tab-pane label="客户资料" name="first" class="customer-tab-pane">
            <el-card class="box-card">
                <div slot="header" class="clearfix card-header">
                    <span class="basicMsg">基本信息</span>
                </div>
                <el-row :gutter="20">
                    <el-col :span="4">
                        <div class="grid-content bg-purple cardTit">姓名</div>
                    </el-col>
                    <el-col :span="8">
                        <div class="grid-content bg-purple">{{ customer.realname }}</div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple cardTit">电话</div>
                    </el-col>
                    <el-col :span="8">
                        <div class="grid-content bg-purple">{{ customer.mobile }}</div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="4">
                        <div class="grid-content bg-purple cardTit">婚期</div>
                    </el-col>
                    <el-col :span="8">
                        <div class="grid-content bg-purple">{{ customer.wedding_date }}</div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple cardTit">联系方式</div>
                    </el-col>
                    <el-col :span="8">
                        <div class="grid-content bg-purple">{{ customer.mobile1 }}</div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="4">
                        <div class="grid-content bg-purple cardTit">桌数</div>
                    </el-col>
                    <el-col :span="8">
                        <div class="grid-content bg-purple">{{ customer.banquet_size }} - {{ customer.banquet_size_end }}</div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple cardTit">预算</div>
                    </el-col>
                    <el-col :span="8">
                        <div class="grid-content bg-purple">{{ customer.budget }} - {{ customer.budget_end }}</div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="4">
                        <div class="grid-content bg-purple cardTit">区域</div>
                    </el-col>
                    <el-col :span="8">
                        <div class="grid-content bg-purple">{{ customer.zone }}</div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple cardTit">咨询酒店</div>
                    </el-col>
                    <el-col :span="8">
                        <div class="grid-content bg-purple">{{ customer.hotel }}</div>
                    </el-col>
                </el-row>
            </el-card>
            <el-card class="box-card">
                <div slot="header" class="clearfix card-header">
                    <span class="basicMsg">系统信息</span>
                </div>
                <el-row :gutter="20">
                    <el-col :span="4">
                        <div class="grid-content bg-purple cardTit">最近联系时间</div>
                    </el-col>
                    <el-col :span="8">
                        <div class="grid-content bg-purple">{{ customer.last_visit_time }}</div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple cardTit">获取客户时间</div>
                    </el-col>
                    <el-col :span="8">
                        <div class="grid-content bg-purple">{{ customer.allocate_time }}</div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="4">
                        <div class="grid-content bg-purple cardTit">创建时间</div>
                    </el-col>
                    <el-col :span="8">
                        <div class="grid-content bg-purple">{{ customer.create_time }}</div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple cardTit">创建人</div>
                    </el-col>
                    <el-col :span="8">
                        <div class="grid-content bg-purple">{{ customer.operator }}</div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="4">
                        <div class="grid-content bg-purple cardTit">来源</div>
                    </el-col>
                    <el-col :span="8">
                        <div class="grid-content bg-purple">{{ customer.source }}</div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple cardTit">客户编号</div>
                    </el-col>
                    <el-col :span="8">
                        <div class="grid-content bg-purple">{{ customer.member_no }}</div>
                    </el-col>
                </el-row>
            </el-card>
        </el-tab-pane>
        <el-tab-pane label="回访记录" name="second" class="customer-tab-pane">
            <el-card class="box-card">
                <div slot="header" class="clearfix card-header">
                    <span class="basicMsg">跟进记录</span>
                </div>
                <div class="chart-data-dimension">
                    <el-table class="chart-data-table" :data="visitGroup" style="width: 100%">
                        <el-table-column prop="visitor" label="回访者" align="center"></el-table-column>
                        <el-table-column prop="visit_times" label="回访次数" align="center"></el-table-column>
                        <el-table-column prop="create_time" label="获取时间" align="center"></el-table-column>
                        <el-table-column prop="status" label="回访状态" align="center"></el-table-column>
                        <el-table-column prop="next_visit_time" label="下次回访时间" align="center"></el-table-column>
                        <el-table-column prop="last_visit_time" label="最近跟进时间" align="center"></el-table-column>
                    </el-table>
                </div>
            </el-card>

            <el-card class="box-card">
                <div slot="header" class="clearfix card-header">
                    <span class="basicMsg">回访历史</span>
                </div>
                <div class="chart-data-dimension">
                    <el-table class="chart-data-table" :data="visitList" style="width: 100%">
                        <el-table-column prop="visitor" label="回访者" width="120" align="center"></el-table-column>
                        <el-table-column prop="create_time" label="回访时间" align="center"></el-table-column>
                        <el-table-column prop="status" label="回访状态" width="120" align="center"></el-table-column>
                        <el-table-column prop="content" label="跟进记录"></el-table-column>
                    </el-table>
                </div>
            </el-card>
        </el-tab-pane>

        <el-tab-pane label="进店记录" name="third" class="customer-tab-pane">
            <div class="record-shop">
                <el-table class="chart-data-table" :data="intoList">
                    <el-table-column prop="status" label="进店状态"></el-table-column>
                    <el-table-column prop="subscribe_time" label="预约进店时间"></el-table-column>
                    <el-table-column prop="real_time" label="实际进店时间"></el-table-column>
                    <el-table-column prop="next_time" label="下次进店时间"></el-table-column>
                    <el-table-column prop="remark" label="备注"></el-table-column>
                </el-table>
            </div>
        </el-tab-pane>

        <el-tab-pane label="回访录音" name="sixth" class="customer-tab-pane">
            <div class="visit-record">
                <el-table class="chart-data-table" :data="callRecord">
                    <el-table-column prop="fwdStartTime" label="日期" width="150" align="center"></el-table-column>
                    <el-table-column prop="operator" label="操作者" align="center"></el-table-column>
                    <el-table-column prop="status" label="接通状态" align="center"></el-table-column>
                    <el-table-column prop="fwdStartTime" label="接通时间" align="center"></el-table-column>
                    <el-table-column prop="billsec" label="持续时间" align="center"></el-table-column>
                    <el-table-column prop="recordFileDownloadUrl" label="录音" align="center">
                        <template slot-scope="scope">
                            <el-link type="success" target="_blank" :href="scope.row.recordFileDownloadUrl">查看</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-tab-pane>
    </el-tabs>
</el-drawer>
</template>

<script>
export default {
    data() {
        return {
            customerDrawer: false,
            activeName: 'first',
            staffList: [],
            increaseData: [],
            callRecord: [],
            visitList: [],
            visitGroup: [],
            customer: {},
            intoList: [],
            applyIds: [],
        }
    },
    methods: {
        // 显示客资详情
        showCustomerDrawer(row) {
            let that = this;
            that.customerDrawer = true;
            // 获取客资信息
            let url = '/api/customer.member/show';
            let query = {
                member_id: row.member_id
            };
            that.$post(url, query).then(function (response) {
                let result = response.data;
                that.customer = result.customer;
                that.visitList = result.visitList;
                that.visitGroup = result.visitGroup;
                that.callRecord = result.callRecord;
                that.intoList = result.intoList;
            });
        },
        // 关闭回访drawer
        closeShowCustomerDrawer() {
            this.customerDrawer = false;
        },
    }
}
</script>
